import React from 'react';
import { Box } from '@chakra-ui/react';
import TablaHerramientas from './TablaHerramientas';

const Herramientas: React.FC = () => {
  return (
    <Box px={{ base: 2, md: 4 }} pt={79} pb={4}>
      <TablaHerramientas />
    </Box>
  );
};

export default Herramientas;
